import CollapsibleComponent from './collapsible.component'

const CollapsibleModule = angular.module('cdbl.collapsible', [

])
  .component('cdblCollapsible', CollapsibleComponent)
  .name

export default CollapsibleModule
